import StringField from './StringField';
import DropdownField from './DropdownField';
import CheckboxField from './CheckboxField';

function FormContent({
  model, displayErrors
}) {

  let fields = model.fields.map((field, index) => {
    switch (field.type) {
      case 'string':
        return <StringField key={index} field={field} displayErrors={displayErrors}/>
      case 'boolean':
        return <CheckboxField key={index} field={field} displayErrors={displayErrors}/>
      case 'choice':
        return <DropdownField key={index} field={field} displayErrors={displayErrors}/>
    }
  });

  return(
    <>
      {fields}
    </>
  )
}

export default FormContent;
